import React, {useState} from 'react'

import {Season} from "../../types/Serials"

import CardContent from "../card/CardContent"
import SeasonCardContent from "../season/SeasonCardContent"

import './styles/serial-seasons.scss'

function SerialFiles() {
    const [seasons, setSeasons] = useState<Season>([{}])

    const onAddSeason = () => {
        setSeasons((prev) => [...prev, {}])
    }

    const onRemove = (index:number) => {
        setSeasons(prev => prev.filter((_, i) => i !== index));
    }

    return (
        <div className="serial-seasons">
            <div className="serial-seasons__cards">
                {
                    seasons.map((season, index) => {
                        return (
                            <CardContent key={index}>
                                <SeasonCardContent index={index} remove={onRemove} />
                            </CardContent>
                        )
                    })
                }
            </div>

            <div>
                <button className="app-btn" onClick={onAddSeason}>Добавить</button>
            </div>
        </div>
    )
}

export default SerialFiles